import React from 'react';

const Popup = ({
  title,
  body,
  handle,
  onClosePopup,
  buttunStyle,
  labelButton,
}) => {
  const onHandleButton = (e) => {
    e.preventDefault();
    handle();
  };
  return (
    <div
      className='modal d-block'
      style={{ backgroundColor: ' rgba(0, 0, 0, 0.7)' }}
    >
      <div className='modal-dialog' style={{ top: 200 }}>
        <div className='modal-content d-block'>
          <div className='modal-header'>
            <h5
              className='modal-title'
              id='exampleModalLabel'
              dangerouslySetInnerHTML={{ __html: title }}
            ></h5>
            <button
              type='button'
              className='close'
              data-dismiss='modal'
              aria-label='Close'
              onClick={onClosePopup}
            >
              <span aria-hidden='true'>&times;</span>
            </button>
          </div>
          <div
            className='modal-body'
            dangerouslySetInnerHTML={{ __html: body }}
          ></div>
          <div className='modal-footer'>
            <button
              type='button'
              className={`btn ${buttunStyle || 'btn-primary'}`}
              onClick={onHandleButton}
            >
              {labelButton || 'Tiếp tục'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Popup;
